import { FormEvent, useCallback, useEffect, useState } from 'react';
import { Col, Row, Input, Avatar, Button, message } from 'antd';
import { CheckOutlined, WhatsAppOutlined, CaretDownOutlined, SearchOutlined, NotificationOutlined, StarFilled, ArrowRightOutlined, ArrowLeftOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { Image, Promotion, Raffle, Ticket } from '../Raffles/interfaces';
import HomeModal from './HomeModal';
import moment from 'moment';
import FullLoader from '../../components/FullLoader/FullLoader';
import HomeModalInfo from './HomeModalInfo';
import { getGenericCollection } from "../../services/firestore";
import { limit, orderBy, where, startAfter } from "firebase/firestore";
import { Box, CircularProgress } from "@mui/material";
import useIsSmallScreen from "../../hooks/useIsSmallScreen";
import { BuyerData } from "../../interfaces/buyer";
import LuckyMachineModal from "./LuckyMachineModal";
import { useLocation, useNavigate } from "react-router-dom";

const Home = () => {
  const [raffle, setRaffle] = useState<Raffle | null>(null);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [openInfo, setOpenInfo] = useState(false);
  const [openLuckyMachine, setOpenLuckyMachine] = useState(false);
  const [ticketsSelected, setTicketsSelected] = useState<Ticket[]>([]);
  const [gettingTickets, setGettingTickets] = useState(false);
  const [search, setSearch] = useState("");
  const [tickets, setTickets] = useState<Ticket[]>([]);
  const [allTickets, setAllTickets] = useState<Ticket[]>([]);
  const [buyerData, setBuyerData] = useState<BuyerData>({
    buyer: "",
    phone: "",
    state: ""
  });
  const [luckyMachineTickets, setLuckyMachineTickets] = useState<Ticket[]>();
  const isSmallScreen = useIsSmallScreen();
  const navigate = useNavigate();

  const init = useCallback(async () => {
    try {
      setLoading(true);

      const raffles = await getGenericCollection<Raffle>("raffles", [where("finalDate", ">", new Date()), where("active", "==", true)]);

      if (!raffles.length) return;

      const _raffle = raffles[0];

      const _tickets = await getGenericCollection<Ticket>("tickets", [where("raffleId", "==", _raffle.id), orderBy("number"), limit(500)]);

      setAllTickets(_tickets);
      setTickets(_tickets);
      setRaffle(_raffle);
    }
    catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    init();
  }, [init]);

  if (loading) return <FullLoader />;

  if (raffle === null) return <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "90vh",
    }}
  >
    <div
      style={{
        display: "block",
        textAlign: "center"
      }}
    >
      <NotificationOutlined
        style={{
          fontSize: 80,
          color: "gray"
        }}
      />
      <br />
      <br />
      <h1>No hay rifas disponibles por el momento</h1>
      <h2>Regresa pronto</h2>
    </div>
  </div>;

  const onScroll = async (e: any) => {
    if (gettingTickets) return;

    const bottom = (e.target.scrollHeight - e.target.scrollTop) < (e.target.clientHeight + 1);
    const startAfterValue = tickets.length || 1;

    if (bottom && startAfterValue < raffle.countTickets) {
      try {
        setGettingTickets(true);

        const _tickets = await getGenericCollection<Ticket>("tickets", [where("raffleId", "==", raffle.id), orderBy("number"), startAfter(startAfterValue), limit(500)]);

        setTickets([...tickets, ..._tickets]);
        setAllTickets([...allTickets, ..._tickets]);
      } catch (error) {
        console.log(error);
      } finally {
        setGettingTickets(false);
      }
    }
  };

  const searchTicket = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!search) {
      setTickets(allTickets);
      return;
    }

    try {
      const _ticket = await getGenericCollection<Ticket>("tickets", [where("raffleId", "==", raffle.id), where("number", "==", parseInt(search))]);

      if (!_ticket.length) {
        message.error("Boleto no encontrado");
        return;
      }

      setTickets(_ticket);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div style={{ textAlign: "center", paddingBottom: 80 }} >
      <div style={{ paddingTop: 60 }}>
        <div
          style={{
            backgroundColor: "orangered",
            color: "white",
          }}
        >
          <br />
          <br />
          <br />
          <h1 style={{ fontSize: 60, fontWeight: "bold" }}>
            {raffle.name.toUpperCase()}
          </h1>
          <h2 style={{ fontSize: 40, marginBottom: 5, marginTop: -20 }}>
            {raffle.description.toUpperCase()}
          </h2>
          <br />
        </div>
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 10,
              backgroundColor: "black",
              color: "white",
            }}
          >
            <CaretDownOutlined style={{ fontSize: 40, color: "orangered" }} />
            <b style={{ fontSize: 30 }}>LISTA DE BOLETOS ABAJO</b>
            <CaretDownOutlined style={{ fontSize: 40, color: "orangered" }} />
          </div>
          <br />
          <div style={{ borderRadius: 20, overflow: "hidden", }}>
            <img
              src={(raffle.image as Image).imageUrl}
              alt="imagenCarro"
              style={{
                objectFit: "contain",
                padding: 10,
                borderRadius: 25,
                width: "auto",
                height: "50vh",
                maxWidth: "100%",
                maxHeight: "100%"
              }}
            />
          </div>
          <br />
          <div
            style={{
              fontSize: 25,
              backgroundColor: "black",
              color: "white",
              display: "flex",
              flexDirection: "column",
              gap: 10,
              paddingTop: 20,
              paddingBottom: 20,
            }}
          >
            <div>
              Precio Boleto: ${raffle.priceTicket.toString().toUpperCase()}
            </div>
            <div style={{ marginTop: -10 }}>
              (SÓLO HASTA {moment(raffle.finalDate?.toDate()).format("DD/MMMM").toUpperCase()})
            </div>
            {
              raffle.promotions.map((promotion: Promotion, index: number) => (
                <div key={index}>
                  <b>{promotion.description}</b>
                </div>
              ))
            }
            <div
              style={{
                paddingTop: 10
              }}
            >
              <Button
                style={{
                  fontWeight: "bold"
                }}
                icon={<CheckCircleOutlined style={{ color: "green" }} />}
                onClick={() => {
                  navigate(
                    "/verificar-boletos",
                    {
                      state: raffle
                    }
                  );
                }}
              >
                VERIFICAR BOLETOS
              </Button>
            </div>
            <div>
              <b>Buscar boleto</b>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <form onSubmit={searchTicket}>
                <div
                  style={{
                    color: "white",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 10
                  }}
                >
                  <Input
                    value={search}
                    type="number"
                    placeholder="BUSCA TU BOLETO AQUÍ"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                    style={{
                      fontSize: 18,
                      fontWeight: "bold",
                    }}
                  />
                  <Button
                    htmlType="submit"
                    icon={<SearchOutlined />}
                    style={{
                      fontWeight: "bold",
                    }}
                    size="large"
                  >
                    BUSCAR
                  </Button>
                </div>
              </form>
            </div>
          </div>
          <br />
          <Box display="flex" justifyContent="center" alignItems="center" >
            <Button
              style={{
                fontWeight: "bold",
                backgroundColor: "green",
                color: "white",
              }}
              size="large"
              onClick={() => setOpenLuckyMachine(true)}
            >
              <div>
                <StarFilled
                  style={{ color: "yellow" }}
                />
                <span style={{ margin: '0 8px' }}>MÁQUINA DE LA SUERTE</span>
                <StarFilled
                  style={{ color: "yellow" }}
                />
              </div>
            </Button>
          </Box>
          <br />
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            width={"100%"}
          >
            <Box>
              <div
                style={{
                  height: 25,
                  backgroundColor: "green",
                  borderRadius: 30,
                  width: 60,
                }}
              >
              </div>
            </Box>
            <Box pl={1} >
              <b style={{ fontSize: 20, paddingRight: 30 }}>Verde - Libre</b>
            </Box>
          </Box>
          <br />
          <Button
            size="large"
            style={{
              color: "white",
              backgroundColor: "orangered",
              fontWeight: "bold",
            }}
            onClick={() => {
              if (!ticketsSelected.length) {
                message.warning("Selecciona al menos un boleto!", 4);
                return;
              }

              setOpen(true);
            }}
          >
            <ArrowRightOutlined />
            APARTAR BOLETOS
            <ArrowLeftOutlined />
          </Button>
          <br />
          <br />
          <div>
            <div
              style={{
                padding: 10,
                maxHeight: "60vh",
                overflowY: "auto",
                border: "1px solid lightgray",
                borderRadius: 10,
              }}
              onScroll={onScroll}
            >
              <Row
                justify="center"
              >
                {
                  tickets.map((ticket: Ticket) => (
                    <Col xs={4} md={2} key={ticket.id} style={{ padding: 2 }}>
                      <div
                        style={{
                          height: 35,
                          cursor: "pointer",
                          backgroundColor: ticket.status === "Libre" ? "green" : "red",
                          borderRadius: 20,
                          color: "white",
                          fontSize: isSmallScreen ? 12 : 16,
                          textAlign: "center",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center"
                        }}
                        onClick={async () => {
                          if (ticket.status !== "Libre") return;

                          if (!ticketsSelected.some(t => t.id === ticket.id)) {
                            setTicketsSelected([...ticketsSelected, ticket]);

                          } else {
                            setTicketsSelected(ticketsSelected.filter(t => t.id !== ticket.id));
                          }
                        }}
                      >
                        <div>
                          {ticketsSelected.some(t => t.id === ticket.id) ? <CheckOutlined /> : ticket.status === "Libre" ? (ticket.number.toString().padStart(6, "0")) : ""}
                        </div>
                      </div>
                    </Col>
                  ))
                }
              </Row>
            </div>
          </div>
          {
            (loading || gettingTickets) && <div style={{ height: 80, maxHeight: 80 }}>
              <div style={{ fontSize: 20 }}>Cargando boletos...</div>
              <CircularProgress size={50} style={{ color: "orangered", padding: 10 }} />
            </div>
          }
        </div>
      </div >
      <a
        href="https://wa.me/527718571117"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Avatar
          style={{
            position: "fixed",
            cursor: "pointer",
            backgroundColor: '#00FF04',
            bottom: "40px",
            right: "40px",
            height: 50,
            width: 50
          }}
        >
          <WhatsAppOutlined style={{ fontSize: 30 }} />
        </Avatar>
      </a>
      <HomeModal
        open={open}
        onClose={() => setOpen(false)}
        onSuccess={(buyerData) => {
          setBuyerData(buyerData);
          setSearch("");
          setOpenInfo(true);
        }}
        ticketIds={luckyMachineTickets ? luckyMachineTickets.map(t => t.id) : ticketsSelected.map(t => t.id)}
      />
      <HomeModalInfo
        raffleName={raffle.name}
        tickets={luckyMachineTickets || ticketsSelected}
        buyerData={buyerData}
        open={openInfo}
        onClose={() => {
          setOpenInfo(false);
          setTicketsSelected([]);
          setLuckyMachineTickets(undefined);
          init();
        }}
        totalAmount={(luckyMachineTickets?.length || ticketsSelected.length) * raffle.priceTicket}
      />
      <LuckyMachineModal
        open={openLuckyMachine}
        onClose={() => setOpenLuckyMachine(false)}
        raffleId={raffle.id}
        countTicketsRaffle={raffle.countTickets}
        onReserveTickets={_tickets => {
          setLuckyMachineTickets(_tickets);
          setOpen(true);
        }}
      />
    </div>
  );
};

export default Home;